var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// components/tabs/common/src/tabs-props.ts
var normalizeCommonFeatures = (properties) => ({
  iconOnly: properties.iconOnly,
  size: properties.size,
  withVerticalBar: properties.withVerticalBar,
  destroyOnHide: properties.destroyOnHide,
  contentUnderneath: properties.contentUnderneath,
  openDropdownsOnHover: properties.openDropdownsOnHover,
  orientation: properties.orientation,
  type: properties.type,
  responsiveMode: properties.responsiveMode,
  classes: properties.classes
});
var normalizeAngularFeatures = (properties) => {
  const commonFeatures = normalizeCommonFeatures(properties);
  return __spreadValues({}, commonFeatures);
};
var normalizeReactFeatures = (properties) => {
  const commonFeatures = normalizeCommonFeatures(properties);
  return __spreadValues({}, commonFeatures);
};

// components/tabs/common/src/tabs-style-sheet.ts
import {
  StyleSheet
} from "@gs-ux-uitoolkit-common/style";
import { colors } from "@gs-ux-uitoolkit-common/design-system";
import {
  createComponentClassDefinitions
} from "@gs-ux-uitoolkit-common/theme";
var tabsStyleSheet = new StyleSheet("tabs", (props) => {
  var _a;
  return createComponentClassDefinitions(
    props,
    createDefaultStyledClasses,
    (_a = props.theme.styleOverrides) == null ? void 0 : _a.tabs
  );
});
function createDefaultStyledClasses({
  theme,
  contentUnderneath,
  minWidth,
  orientation,
  size = "md",
  type,
  justify
}) {
  return {
    root: {
      display: "flex",
      flexFlow: contentUnderneath ? "column" : "row",
      minWidth: `${minWidth}px`
    },
    container: __spreadProps(__spreadValues(__spreadValues({
      display: "flex",
      flexWrap: "wrap",
      paddingLeft: 0,
      listStyle: "none",
      boxSizing: "border-box",
      marginTop: 0,
      marginBottom: "16px"
    }, navTabContainerStyles(theme, type, orientation)), borderForVerticalTabs(type, orientation)), {
      ".nav-item": __spreadProps(__spreadValues({}, navItemStyles(justify, orientation, type)), {
        "&.dropdown": {
          position: "relative"
        },
        ".nav-link": __spreadValues({}, navLinkStyles(size, theme, type, orientation)),
        ".dropdown-menu": __spreadProps(__spreadValues({}, dropdownMenuStyles(theme, type)), {
          ".dropdown-item": __spreadValues({}, dropdownItemStyles(theme, size))
        })
      })
    }),
    content: __spreadProps(__spreadValues({}, theme.typography.body02), {
      p: {
        margin: "6px 0 12px"
      },
      ".tab-pane": {
        display: "none",
        "&.active": {
          display: "block"
        }
      }
    })
  };
}
var tabsSizeVariants = {
  md: {
    tabItemHeight: "40px",
    tabItemMarginRight: "16px",
    tabItemPadding: "9px 0px",
    tabItemTypography: "body02",
    tabItemSelectedTypography: "heading06",
    dropdownMenuItemPadding: "6px 16px",
    dropdownMenuItemTypography: "body02"
  },
  lg: {
    tabItemHeight: "48px",
    tabItemMarginRight: "24px",
    tabItemPadding: "11px 0px",
    tabItemTypography: "body01",
    tabItemSelectedTypography: "heading05",
    dropdownMenuItemPadding: "10px 24px",
    dropdownMenuItemTypography: "body01"
  }
};
function getOrientationStyle(orientation) {
  if (orientation === "vertical") {
    return {
      borderLeftColor: colors.blue060
    };
  } else {
    return {
      borderBottom: `2px solid ${colors.blue060}`
    };
  }
}
function borderForVerticalTabs(type, orientation) {
  if (type === "tabs" && orientation === "vertical") {
    return {
      height: "100%",
      borderBottom: "none",
      width: "160px"
    };
  }
  return {};
}
function navTabContainerStyles(theme, type, orientation) {
  let styles = {};
  if (orientation === "vertical") {
    styles = {
      flexDirection: "column"
    };
  }
  if (type === "tabs") {
    styles = __spreadProps(__spreadValues({}, styles), {
      minHeight: "40px",
      borderBottom: `2px solid ${theme.border.minimal}`
    });
  }
  return styles;
}
function navItemStyles(justify, orientation, type) {
  if (type === "tabs") {
    let justifyStyles = {};
    if (orientation === "horizontal") {
      if (justify === "justified") {
        justifyStyles = {
          flex: "1 1 auto",
          textAlign: "center"
        };
      } else if (justify === "fill") {
        justifyStyles = {
          flexBasis: 0,
          flexGrow: 1,
          textAlign: "center"
        };
      }
    }
    return __spreadValues({
      marginBottom: "-2px",
      whiteSpace: "nowrap"
    }, justifyStyles);
  }
  return {};
}
function navLinkStyles(size, theme, type, orientation) {
  let styles = {
    display: "block",
    padding: "8px 16px",
    textDecoration: "none",
    boxSizing: "border-box",
    "&:hover, &:focus": {
      textDecoration: "none"
    },
    "&.disabled": {
      opacity: 0.3,
      pointerEvents: "none",
      cursor: "default"
    },
    "&.show": {
      color: colors.gray070,
      backgroundColor: "white",
      borderColor: `${colors.gray020} ${colors.gray020} white`
    }
  };
  if (type === "tabs") {
    styles = __spreadProps(__spreadValues(__spreadValues({}, styles), theme.typography[tabsSizeVariants[size].tabItemTypography]), {
      padding: tabsSizeVariants[size].tabItemPadding,
      marginRight: tabsSizeVariants[size].tabItemMarginRight,
      backgroundColor: "initial",
      border: "none",
      color: theme.text.primary,
      height: tabsSizeVariants[size].tabItemHeight,
      "&:hover": {
        color: theme.text.link
      },
      "&:active": {
        borderRadius: "0"
      },
      "&.active": __spreadValues(__spreadProps(__spreadValues({}, getOrientationStyle(orientation)), {
        color: theme.text.link
      }), theme.typography[tabsSizeVariants[size].tabItemSelectedTypography]),
      "&.disabled": {
        pointerEvents: "none",
        cursor: "default",
        opacity: 0.3
      }
    });
    if (orientation === "vertical") {
      styles = __spreadProps(__spreadValues({}, styles), {
        padding: "10px 0px 10px 12px",
        borderTopLeftRadius: "0px",
        borderLeft: `2px solid ${theme.border.minimal}`
      });
    }
  }
  if (type === "pills") {
    styles = __spreadProps(__spreadValues(__spreadValues({}, styles), theme.typography[tabsSizeVariants[size].tabItemTypography]), {
      borderRadius: "4px",
      color: theme.text.link,
      "&:hover:not(&.active)": {
        color: theme.text.link,
        backgroundColor: theme.getColorInteractionShades("primary", "minimal").hover
      },
      "&.active, .show": {
        borderColor: `${theme.border.minimal} ${theme.border.minimal} white`,
        backgroundColor: theme.text.link,
        color: theme.text.reversed
      }
    });
  }
  return styles;
}
function dropdownMenuStyles(theme, type) {
  const surfaceShades = theme.getSurfaceInteractionShades("primary");
  let styles = {
    position: "absolute",
    top: "100%",
    left: 0,
    zIndex: 1e3,
    display: "none",
    float: "left",
    minWidth: "160px",
    padding: "4px 0",
    margin: "2px 0 0",
    textAlign: "left",
    listStyle: "none",
    backgroundColor: theme.elevation["05"].background,
    backgroundClip: "padding-box",
    border: `1px solid ${surfaceShades.border}`,
    borderRadius: "4px",
    "&[x-placement^='top'], &[x-placement^='right'], &[x-placement^='bottom'], &[x-placement^='left']": {
      right: "auto",
      bottom: "auto"
    },
    outline: "none",
    boxShadow: theme.elevation["05"].shadow,
    "&.show": {
      display: "block"
    }
  };
  if (type === "tabs") {
    styles = __spreadProps(__spreadValues({}, styles), {
      marginTop: "-1px",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0
    });
  }
  return styles;
}
function dropdownItemStyles(theme, size) {
  const surfaceShades = theme.getSurfaceInteractionShades("primary");
  const styles = __spreadProps(__spreadValues({
    display: "block",
    width: "100%",
    padding: tabsSizeVariants[size].dropdownMenuItemPadding,
    clear: "both",
    color: theme.text.primary,
    textAlign: "inherit",
    whiteSpace: "nowrap",
    backgroundColor: "transparent",
    border: 0
  }, theme.typography[tabsSizeVariants[size].dropdownMenuItemTypography]), {
    outline: "none",
    "&:hover, &:focus": {
      background: surfaceShades.hover,
      cursor: "pointer"
    },
    "&:active": {
      background: surfaceShades.active,
      cursor: "pointer"
    },
    "&.disabled": {
      opacity: theme.state.disabledOpacity,
      pointerEvents: "none",
      backgroundColor: "transparent"
    }
  });
  return styles;
}

// components/tabs/common/src/tab-style-sheet.ts
import {
  StyleSheet as StyleSheet2
} from "@gs-ux-uitoolkit-common/style";
import { getIconStyles } from "@gs-ux-uitoolkit-common/icon-font";
import { createComponentClassDefinitions as createComponentClassDefinitions2 } from "@gs-ux-uitoolkit-common/theme";
var tabStyleSheet = new StyleSheet2("tab", (props) => {
  var _a;
  return createComponentClassDefinitions2(
    props,
    createDefaultStyledClasses2,
    (_a = props.theme.styleOverrides) == null ? void 0 : _a.tab
  );
});
function createDefaultStyledClasses2({
  size = "md",
  showExpandIcon,
  iconOnly,
  isDropdownOpen = false,
  orientation
}) {
  return {
    leadingIcon: {
      marginRight: iconOnly ? "0px" : tabSizeVariants[size].iconMarginRight,
      fontSize: tabSizeVariants[size].iconFontSize
    },
    dropdownToggle: __spreadValues({}, getExpandIconStyles({
      showExpandIcon,
      isDropdownOpen,
      orientation,
      size
    }))
  };
}
function getExpandIconStyles({
  size,
  orientation,
  showExpandIcon,
  isDropdownOpen
}) {
  if (!showExpandIcon) {
    return {};
  }
  return {
    "::after": __spreadProps(__spreadValues({}, getIconStyles({
      name: isDropdownOpen ? getOpenedDropdownToggleStyleName(orientation) : getClosedDropdownToggleStyleName(orientation),
      type: "filled",
      size
    })), {
      marginLeft: "7px"
    })
  };
}
function getOpenedDropdownToggleStyleName(orientation) {
  if (orientation === "vertical") {
    return "keyboard-arrow-left";
  }
  return "keyboard-arrow-up";
}
function getClosedDropdownToggleStyleName(orientation) {
  if (orientation === "vertical") {
    return "keyboard-arrow-right";
  }
  return "keyboard-arrow-down";
}
var tabSizeVariants = {
  md: {
    iconFontSize: "20px",
    iconMarginRight: "8px"
  },
  lg: {
    iconFontSize: "24px",
    iconMarginRight: "10px"
  }
};

// components/tabs/common/src/tabs-util.ts
import { cx } from "@gs-ux-uitoolkit-common/style";
var globalTabsClassName = "gs-tabs";
var globalTabClassName = "gs-tab";
var getTabsRootClasses = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(cssClasses.root, overrideClasses == null ? void 0 : overrideClasses.root, globalTabsClassName);
};
var getTabsContainerClasses = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.container,
    overrideClasses == null ? void 0 : overrideClasses.container,
    `${globalTabsClassName}__container`
  );
};
var getTabsContentClasses = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(cssClasses.content, overrideClasses == null ? void 0 : overrideClasses.content, `${globalTabsClassName}__content`);
};
var getTabLeadingIconClasses = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.leadingIcon,
    overrideClasses == null ? void 0 : overrideClasses.leadingIcon,
    `${globalTabClassName}__leadingIcon`
  );
};
var getDropdownToggleClasses = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx("nav-link", cssClasses.dropdownToggle, overrideClasses == null ? void 0 : overrideClasses.dropdownToggle);
};
export {
  getDropdownToggleClasses,
  getTabLeadingIconClasses,
  getTabsContainerClasses,
  getTabsContentClasses,
  getTabsRootClasses,
  normalizeAngularFeatures as normalizeTabsAngularFeatures,
  normalizeReactFeatures as normalizeTabsReactFeatures,
  tabStyleSheet,
  tabsStyleSheet
};
//# sourceMappingURL=index.mjs.map
